import { Notification } from '@copera/notification';
import { Stack } from '@mui/material';
import { useRef } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { NotificationListItemContainer } from './NotificationListItemContainer';

type NotificationListProps = {
  items: Notification[];
  onClose: () => void;
};

export const NotificationList = ({ items, onClose }: NotificationListProps) => {
  const parentRef = useRef<HTMLDivElement | null>(null);

  const itemContent = (index: number, notification: Notification) => (
    <NotificationListItemContainer
      items={items}
      onClose={onClose}
      notification={notification}
      index={index}
      parentEl={parentRef.current}
    />
  );

  return (
    <Stack ref={parentRef} flexGrow={1} sx={{ overflow: 'hidden' }}>
      <Virtuoso
        itemContent={itemContent}
        data={items}
        increaseViewportBy={270}
        computeItemKey={(index) => `speach_${index}`}
      />
    </Stack>
  );
};
